import { Grid } from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { TabTeenagerProps } from '../..'
import { WorkingGroup } from 'pages/CreateHearing/components/StepIdentification/components/WorkingGroup'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import FormInput from 'components/FormInput'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import { useHearingIdentificationBlockFieldsContext } from 'contexts/hearing-identification-block-fields.context'

const motivosOptions: ItemOption[] = [
  { value: 'DESEMPENHO_ENTREVISTA', label: 'a) Desempenho na entrevista' },
  { value: 'BAIXA_ESCOLARIDADE', label: 'b) Baixa escolaridade' },
  { value: 'DISTANCIA_LOCAL_APRENDIZAGEM', label: 'c) Distância casa- local de aprendizagem' },
  { value: 'TURNO_INCOMPATIVEL', label: 'd) Turno escolar incompatível' },
  { value: 'DESINTERESSE', label: 'e) Desinteresse pelo curso de formação' },
]

const motivosNaoAdesaoOptions: ItemOption[] = [
  { value: 'FALTAS', label: 'a) Faltas' },
  { value: 'SOBRECARGA', label: 'b) Sobrecarga de atividades' },
  {
    value: 'DIFICULDADE_ACOMPANHAR_CURSO',
    label: 'c) Dificuldade em acompanhar conteúdo do curso de formação',
  },
  { value: 'DESINTERESSE_CURSO', label: 'd) Desinteresse pelo curso de formação' },
  { value: 'ABANDONO_ESCOLAR', label: 'e) Abandono escolar' },
  {
    value: 'OPORUNIDADE_MELHO_REMUNERACAO',
    label: 'f) Acesso a oportunidades de melhor remuneração',
  },
  { value: 'MATERNIDADE_PATERNIDADE', label: 'g) Priorização da maternidade/paternidade' },
  { value: 'DISTANCIA_LOCAL_APRENDIZAGEM', label: 'h) Distância casa- local de aprendizagem' },
  { value: 'NOVA_APREENSAO', label: 'i) Nova Apreensão' },
  { value: 'ABANDONO_SEM_EXPLICACAO', label: 'j) Abandono sem explicação' },
]

export const TabProfessionalData: React.FC<TabTeenagerProps> = () => {
  const { isBlockedFields } = useHearingIdentificationBlockFieldsContext()
  const { control, watch, setValue } = useFormContext<HearingIdentificationType>()

  const isInseridoJovemAprendiz = watch('identificacaoAdolescente.inseridoJovemAprendiz')
  const isApresentaAreaInteresse = watch(
    'identificacaoAdolescente.apresentaAreaInteresseJovemAprendiz',
  )

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Label text='Dados profissionais' v='h6' color='primary' bold />
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <WorkingGroup control={control} watch={watch} setValue={setValue} />
          <Grid item lg={12} xs={12}>
            <FormControlRadio
              control={control}
              name='identificacaoAdolescente.inseridoJovemAprendiz'
              label='Inserido no Jovem Aprendiz?'
              options={radioButtonChoiceOptions}
              disabled={isBlockedFields}
            />
          </Grid>
          {isInseridoJovemAprendiz === 'S' && (
            <>
              {/*<Grid item lg={3} xs={12}>
                <FormInputDatePicker
                  name='identificacaoAdolescente.dataInicioJovemAprendiz'
                  label='Data de Inicio'
                  control={control}
                  enableFuture={true}
                  disabled={isBlockedFields}
                />
              </Grid>*/}
              <Grid item lg={3} xs={12}>
                <FormInput
                  name='identificacaoAdolescente.empresaJovemAprendiz'
                  label='Empresa'
                  control={control}
                  disabled={isBlockedFields}
                />
              </Grid>
              <Grid item lg={3} xs={12}>
                <FormInput
                  name='identificacaoAdolescente.contatoJovemAprendiz'
                  label='Contato'
                  control={control}
                  disabled={isBlockedFields}
                />
              </Grid>
              <Grid item lg={3} xs={12}>
                <FormInput
                  name='identificacaoAdolescente.turnoJovemAprendiz'
                  label='Turno'
                  control={control}
                  disabled={isBlockedFields}
                />
              </Grid>
              <Grid item lg={isApresentaAreaInteresse === 'S' ? 4 : 12} xs={12}>
                <Grid item lg={2} xs={12}>
                  <FormControlRadio
                    control={control}
                    name='identificacaoAdolescente.apresentaAreaInteresseJovemAprendiz'
                    label='Apresenta Interesse?'
                    options={radioButtonChoiceOptions}
                    disabled={isBlockedFields}
                  />
                </Grid>
                {isApresentaAreaInteresse && (
                  <>
                    <Grid item lg={8} xs={12}>
                      <FormInput
                        name='identificacaoAdolescente.objetivoAreaInteresseJovemAprendiz'
                        label='Qual o Objetivo?'
                        control={control}
                        disabled={isBlockedFields}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </>
          )}
          {isInseridoJovemAprendiz !== null && isInseridoJovemAprendiz === 'N' && (
            <>
              <Grid item md={5} xs={12}>
                <FormInputSelect
                  control={control}
                  name='identificacaoAdolescente.motivoNaoAdesaoJovemAprendiz'
                  label='Motivo'
                  options={motivosOptions}
                />
              </Grid>
              <Grid item md={5} xs={12}>
                <FormInputSelect
                  control={control}
                  name='identificacaoAdolescente.motivoNaoInseridoJovemAprendiz'
                  label='Não Adesão'
                  options={motivosNaoAdesaoOptions}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
